import { Award } from 'lucide-react';

/**
 * Airbnb Superhost recognition badge for Lalita.
 * Variants:
 *   - "light"  : light pill for use over dark / image backgrounds (default)
 *   - "dark"   : dark pill for use over light backgrounds
 *   - "compact": minimal inline label for tight spaces
 */
const SuperhostBadge = ({ variant = 'light', className = '' }) => {
  const base =
    'inline-flex items-center gap-2 rounded-full font-body text-xs sm:text-sm font-medium whitespace-nowrap';

  const variants = {
    light:
      'bg-white/15 backdrop-blur-sm border border-white/30 text-white px-3 py-1.5',
    dark:
      'bg-white border border-temple-gold/40 text-charcoal shadow-sm px-3 py-1.5',
    compact:
      'bg-temple-gold/10 text-charcoal border border-temple-gold/40 px-2.5 py-1',
  };

  return (
    <span
      className={`${base} ${variants[variant] || variants.light} ${className}`}
      data-testid="superhost-badge"
      title="Recognized as a Superhost on Airbnb"
    >
      <Award className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-temple-gold" />
      <span>Airbnb Superhost</span>
    </span>
  );
};

export default SuperhostBadge;
